<!-- ========== Left Sidebar Start ========== -->

<!--- Sidemenu -->

<ul class="metismenu" id="side-menu" #sideMenu>
  <ng-container *ngFor="let item of menuItems">
    <li class="side-nav-title side-nav-item menu-title" *ngIf="item.isTitle">{{ item.label }}
    </li>

    <li *ngIf="!item.isTitle" [routerLink]="[item.link]"  routerLinkActive="mm-active" >

      <a *ngIf="hasItems(item)" href="javascript:void(0);" class="side-nav-link">
        <i [attr.data-feather]="item.icon" class="icon-dual icon-xxl" appFeatherIcon *ngIf="item.icon"></i>
        <span> {{ item.label }}</span>
        <span class="menu-arrow"></span>
      </a>

      <a  *ngIf="!hasItems(item)" class="side-nav-link side-nav-link-ref"
        [attr.data-parent]="item.parentId">
        <i [attr.data-feather]="item.icon" appFeatherIcon *ngIf="item.icon"></i>
        <i *ngIf="item?.badgeIcon"  [attr.data-feather]="item?.badgeIcon.icon" class="{{item?.badgeIcon.class}} float-right"  appFeatherIcon ></i>

        <span> {{ item.label }}</span>
        <span routerLinkActive="router-link-active"
          class="badge rounded-circle badge-{{item.badge.variant}} float-right" (click)="$event.stopPropagation()"  [routerLink]="[item.badge.route]"
          *ngIf="item.badge">
          {{item.badge.text}}
        </span>
      </a>

    </li>
  </ng-container>
  <sn-placeholder-loading *ngIf="(loadingProjects$ | async)">
    <sn-placeholder-row>
      <sn-placeholder-item [style]='loadingStyle'></sn-placeholder-item>
    </sn-placeholder-row>
    <sn-placeholder-row></sn-placeholder-row>
    <sn-placeholder-row>
      <sn-placeholder-item [style]='loadingStyle'></sn-placeholder-item>
    </sn-placeholder-row>
    <sn-placeholder-row></sn-placeholder-row>
    <sn-placeholder-row>
      <sn-placeholder-item [style]='loadingStyle'></sn-placeholder-item>
    </sn-placeholder-row>
    <sn-placeholder-row></sn-placeholder-row>
    <sn-placeholder-row>
      <sn-placeholder-item [style]='loadingStyle'></sn-placeholder-item>
    </sn-placeholder-row>
    <sn-placeholder-row></sn-placeholder-row>
    <sn-placeholder-row>
      <sn-placeholder-item [style]='loadingStyle'></sn-placeholder-item>
    </sn-placeholder-row>
  </sn-placeholder-loading>
</ul>
